import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ExternalLink, Check } from 'lucide-react';

// Normalises API save errors: detail may be a string or { message, field, duplicate }.
export const parseSaveError = (err, fallback = 'Failed to save') => {
  const detail = err?.response?.data?.detail;
  if (!detail) return { message: fallback, duplicate: null, field: '' };
  if (typeof detail === 'string') return { message: detail, duplicate: null, field: '' };
  return { message: detail.message || fallback, duplicate: detail.duplicate || null, field: detail.field || '' };
};

const DuplicateAlert = ({ error, entityType = 'client', onUseExisting, testIdPrefix = '' }) => {
  if (!error) return null;
  const { message, duplicate, field } = error;
  const Icon = AlertTriangle;
  if (!duplicate) {
    return <div className="text-sm text-red-600" data-testid={`${testIdPrefix}error`}>{message}</div>;
  }
  const detailPath = `/${entityType}s/${duplicate.id}`;
  const org = entityType === 'client' ? duplicate.company : duplicate.firm;
  return (
    <div
      className="rounded-lg border p-3 text-sm space-y-2"
      style={{ background: '#fff5f5', borderColor: '#fca5a5' }}
      data-testid={`${testIdPrefix}duplicate-alert`}
    >
      <div className="flex items-start gap-2 text-red-700">
        <Icon size={16} className="mt-0.5 shrink-0" />
        <div>
          <div className="font-semibold">Duplicate {field} — not saved</div>
          <div className="text-red-600">{message}</div>
        </div>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2 pl-6">
        <div className="text-gray-700">
          <span className="font-medium">{duplicate.name}</span>
          {org && <span className="text-xs ml-1.5 text-gray-500">· {org}</span>}
          {duplicate.phone && <span className="text-xs ml-1.5 font-mono-data text-gray-500">{duplicate.phone}</span>}
          {duplicate.email && <span className="text-xs ml-1.5 text-gray-500">{duplicate.email}</span>}
        </div>
        {onUseExisting ? (
          <button type="button" onClick={() => onUseExisting(duplicate)} className="btn btn-outline btn-sm" data-testid={`${testIdPrefix}use-existing-btn`}>
            <Check size={13} /> Use existing
          </button>
        ) : (
          <Link to={detailPath} className="btn btn-outline btn-sm" data-testid={`${testIdPrefix}open-existing-link`}>
            <ExternalLink size={13} /> Open existing
          </Link>
        )}
      </div>
    </div>
  );
};

export default DuplicateAlert;
